import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, Subscription} from 'rxjs';
import {FormBuilder, FormGroup} from '@angular/forms';
import {IFilterView, IPaginatorView, ISortView, PaginatorState, SortState} from "../crud-table";
import {HttpClient} from "@angular/common/http";
import {SweetAlertService} from "../shared/services/common/sweet-alert.service";

@Component({
  selector: 'app-base-bpmn-pages',
  template: ``,
  styles: [],
})

export class BaseCrudBpmnPagesComponent implements OnInit, OnDestroy, ISortView, IFilterView, IPaginatorView {
  isLoading: boolean;
  public subscriptions: Subscription[] = [];
  filterGroup: FormGroup;
  sorting: SortState;
  paginator: PaginatorState;
  arrFormGroups: any[] = [];
  protected http: HttpClient;
  taskDef = '';
  arrVar = [];
  arrDto = [];
  arrDecision = [];
  arrTasks = [];
  allSpec = {};
  loadingStart = false;

  //FOR BPMN
  diagramUrl = ``;
  isCollapsed = false;
  title = 'bpmn-js-angular';
  importError?: Error;

  alertShow = false;
  alertType = 'primary';
  alertMessage = '';

  syncFoo = "foo";
  testEmitter$ = new BehaviorSubject<any>(this.syncFoo);

  constructor(
    @Inject('') protected tableService: any,
    protected fb: FormBuilder
  ) {
  }

  paginate(paginator: PaginatorState) {
    this.tableService.patchStateBpmn({paginator}, this.taskDef);
  }

  create() {
    this.edit(undefined, 'edit', 'init');
  }

  //OVERRIDE THIS
  editComponentShow(id, type, typeTask, transFormArrForm, transFormArrVar, transFormArrDecision, typeDecision) {

  }

  edit(id: number, type: string = 'edit', typeTask = null) {
    let transFormArrForm = [];
    let transFormArrVar = [];
    let transFormArrDecision = [];
    let typeDecision = '';
    for (const key in this.allSpec) {
      if (key === typeTask) {
        const obj = this.allSpec[key];
        if (obj.hasOwnProperty('decision')) {
          if (obj.decision.hasOwnProperty('exclusive')) {
            transFormArrDecision = obj.decision.exclusive;
            typeDecision = 'radio';
          }
          if (obj.decision.hasOwnProperty('inclusive')) {
            transFormArrDecision = obj.decision.inclusive;
            typeDecision = 'checkbox';
          }
        }
        if (obj.hasOwnProperty('variable')) {
          transFormArrVar = obj.variable.map((el) => {
            return {
              title: el.label,
              form: el.name,
              type: 'text',
              mandatory: el.required
            };
          });
        }
        if (obj.hasOwnProperty('dto')) {
          transFormArrForm = obj.dto.map((el) => {
            const typeTemp = el.type == 'String' || el.type == 'string' ? 'text' : el.type ? el.type : 'text';
            if (typeTemp == 'radio' || typeTemp == 'checkbox') {
              let tempJson = el.metadata.jsonValues;
              el.metadata = {
                ...el.metadata,
                jsonValues: typeof tempJson === 'string' ? JSON.parse(tempJson) : tempJson
              };
            }
            return {
              title: el.label,
              form: el.name,
              type: typeTemp ? typeTemp.toLowerCase() : typeTemp,
              mandatory: el.required,
              metaData: el.metadata
            };
          });
        }
      }
    }
    this.editComponentShow(id, type, typeTask, transFormArrForm, transFormArrVar, transFormArrDecision, typeDecision);
  }

  // OVERRIDE THIS FOR FILTER
  filterForm() {

  }

  // OVERRIDE THIS FOR FILTER
  filter() {

  }

  sort(column: string): void {
    const sorting = this.sorting;
    const isActiveColumn = sorting.column === column;
    if (!isActiveColumn) {
      sorting.column = column;
      sorting.direction = 'asc';
    } else {
      sorting.direction = sorting.direction === 'asc' ? 'desc' : 'asc';
    }
    this.tableService.patchStateBpmn({sorting}, this.taskDef);
  }

  ngOnInit(): void {
    this.tableService.setDefaults();
    this.loadingStart = true;
    this.filterForm();
    this.tableService.fetchBpmn(this.taskDef);
    const sb = this.tableService.isLoading$.subscribe((res) => {
      this.isLoading = res
    });
    this.tableService.fetchBpmnInit(this.taskDef);
    // sub specifications
    this.tableService.listSpecInit$.subscribe((res) => {
      this.allSpec = {
        ...this.allSpec,
        ...res
      }
    })
    // sub tasks
    this.tableService.listTasks$.subscribe((res) => {
      this.arrTasks = res;
      if (this.arrTasks.length) {
        this.tableService.fetchAllSpecInit(this.arrTasks);
      }
    }, (error) => {
      this.loadingStart = false;
    })
    // sub all specification
    this.tableService.listSpecAll$.subscribe((res) => {
      this.allSpec = {
        ...this.allSpec,
        ...res
      }
      if (Object.keys(res).length !== 0) {
        this.testEmitter$.next("foo");
        this.loadingStart = false;
      }
    }, (error) => {
      this.loadingStart = false;
    })
    this.tableService.errorMessage$.subscribe((res) => {
      if (typeof res == 'object') {
        if (res.hasOwnProperty('error')) {
          SweetAlertService.swalError(res);
        }
      }
    })
    this.subscriptions.push(sb);
    this.sorting = this.tableService.sorting;
    this.paginator = this.tableService.paginator;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  getSpecData(typeTask) {
    this.tableService.getSpec('dto', typeTask).subscribe((res: any) => {
      const dataTemp = res.data.map((item) => {
        return {
          title: item.label,
          form: item.name,
          type: 'text',
          mandatory: item.required
        }
      })
      this.arrDto = [...dataTemp]
    });
    this.tableService.getSpec('variable', typeTask).subscribe((res: any) => {
      const dataTemp = res.data.map((item) => {
        return {
          title: item.label,
          form: item.name,
          type: 'text',
          mandatory: item.required
        }
      })
      this.arrVar = [...dataTemp]
    });
  }

  closeAlert() {
    this.alertShow = false;
    this.alertMessage = '';
  }

  clearVar() {
    this.alertShow = false;
    this.alertType = 'primary';
    this.alertMessage = '';
  }

  handleImported(event) {
    const {
      type,
      error,
      warnings
    } = event;

    if (type === 'success') {
      console.log(`Rendered diagram (%s warnings)`, warnings.length);
      this.isCollapsed = true;
    }

    if (type === 'error') {
      console.error('Failed to render diagram', error);
    }

    if (type === 'click') {
      this.taskDef = warnings;
      this.tableService.fetchBpmn(this.taskDef)
    }

    this.importError = error;
  }
}
